import React from "react";
import { Box, Container, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import "./projects.css";
import GitHubIcon from '@mui/icons-material/GitHub';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const Projects = () => {
  return (
    <div className="project-sec" id="project-section">
      <Container>
          <Typography variant="h4" className="project-heading" data-aos="zoom-out" data-aos-duration="3000">
            Things <span>I've Built .</span>
          </Typography>
          {/* --- Project 1 --- */}
        <Grid container spacing={2} className="project-row">
          <Grid xs={12} sm={6} md={6} lg={6} className="project-left" data-aos="fade-up" data-aos-duration="1000">
            <div className="project-img">
                <img src="./images/E-Health-Care Home1.png" alt="E-Health-Care Home" />
            </div>
          </Grid>
          <Grid xs={12} sm={6} md={6} lg={6} className="project-right" data-aos="fade-up" data-aos-duration="1000">
            <Typography variant="h4" className="project-title">
                  E-Health-Care System
              </Typography>
              <Typography variant="subtitle2" className="project-desc">
              E-Health Care System is a web-based system designed that helps to connect patients and doctors virtually. E-Health Care System provides an ease to patients, where couple of medical specialist are visible to them. Patient can Schedule their appointment, receive instant response, also can send feedback.
              </Typography>
              <Box className="project-lang-box">
                <Typography variant="subtitle1" className="project-lang">
                    React JS
                </Typography>
                <Typography variant="subtitle1" className="project-lang">
                    Node JS
                </Typography>
                <Typography variant="subtitle1" className="project-lang">
                    MongoDB
                </Typography>
                <Typography variant="subtitle1" className="project-lang">
                    BootStrap
                </Typography>
              </Box>
              <Box className="project-link-box">
                <Typography component="a" href="https://github.com/ahsan-chy/E-Health-Care" variant="subtitle1" className="project-link">
                    Git Hub <GitHubIcon className="icon"/>
                </Typography>
                <Typography component="a" href="https://www.youtube.com/watch?v=niosR-esld0" variant="subtitle1" className="project-link">
                    Demo Link <OpenInNewIcon className="icon"/>
                </Typography>
              </Box>
            </Grid>

        </Grid>

          {/* --- Project 2 --- */}
        <Grid container spacing={2} className="project-row">
        <Grid xs={12} sm={6} md={6} lg={6} className="project-right" data-aos="fade-up" data-aos-duration="1000" >
            <Typography variant="h4" className="project-title">
                  Hello Store
              </Typography>
              <Typography variant="subtitle2" className="project-desc">
              Hello Store is an e-commerce website that allows users to view a wide range of products and purchase their desired items with ease. Our platform is designed to offer customers an intuitive and seamless shopping experience, making it easier than ever to find what they need and complete their purchases quickly. <br/> One of the key features of our website is our use of <b>STRAPI</b> as a backend server. 
              </Typography>
              <Box className="project-lang-box">
                <Typography variant="subtitle1" className="project-lang">
                    React JS
                </Typography>
                <Typography variant="subtitle1" className="project-lang">
                    Material UI
                </Typography>
                <Typography variant="subtitle1" className="project-lang">
                    Strapi
                </Typography>
                <Typography variant="subtitle1" className="project-lang">
                    React Redux
                </Typography>
              </Box>
              <Box className="project-link-box">
              <Typography component="a" href="https://github.com/ahsan-chy/Hello-Store-Mui" variant="subtitle1" className="project-link">
                    Git Hub <GitHubIcon className="icon"/>
                </Typography>
                {/* <Typography component="a" href="/" variant="subtitle1" className="project-link">
                    Live Preview <OpenInNewIcon className="icon"/>
                </Typography> */}
              </Box>
            </Grid>
          <Grid xs={12} sm={6} md={6} lg={6} className="project-left" data-aos="fade-up" data-aos-duration="1000">
            <div className="project-img">
                <img src="./images/Hello-Store-MUI.png" alt="Hello-Store-MUI" />
            </div>
          </Grid>
          
        </Grid>

      </Container>
    </div>
  );
};

export default Projects;
